import {
  CANCEL_CONFIRM_WINDOW_BY_USER_ANNOTATION,
  CUSTOM_ERROR_KEYS,
  CUSTOM_ERROR_MAPPING,
} from "../constants";
import { hasCancelPluginWindowByUser } from "./has-cancel-plugin-window-by-user";
import { hasInvalidPinCode } from "./has-invalid-pin-code";

export const getCustomErrorText = (error: string) => {
  if (hasInvalidPinCode(error)) {
    return CUSTOM_ERROR_KEYS.INVALID_PINCODE;
  }

  if (hasCancelPluginWindowByUser(error)) {
    return CANCEL_CONFIRM_WINDOW_BY_USER_ANNOTATION;
  }

  return CUSTOM_ERROR_MAPPING[error] || error;
};
